import { getAccessToken } from '../auth';
import { environment } from '../environment';
import { createApi, createAxios } from './api';
export const ManagerApi = createApi({
    getAccessToken,
    baseURL: environment.managerUrl,
    isEmployee: false,
});
export const EmployeeApi = createApi({
    getAccessToken,
    baseURL: environment.url,
    isEmployee: true,
});
export const managerAxios = createAxios({
    getAccessToken,
    baseURL: environment.managerUrl,
});
